module.exports = __webpack_public_path__ + "static/media/  (30).5b2bcdc0.jpg";